import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 0 20px;

  width: 100vw;
  height: 100%;
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.light_gray};

  display: flex;
  flex-direction: column;
  align-items: center;

  .div_top {
    display: flex;
    flex-direction: column;
    z-index: 10;
    justify-content: space-between;
    align-items: center;
    gap: 32px;

    width: 100vw;

    margin-top: 50px;
    margin-bottom: 30px;
    padding: 0 20px 0 20px;

    > .div_top_selector {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;

      path {
        fill: #4d4d4d;
      }

      .selector_box {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        border: 1px solid white;
        border-radius: 25px;
        padding: 6px 24px;
      }

      span {
        color: #4d4d4d;
      }
    }

    > .title {
      margin-top: 20px;

      h1 {
        font-size: 18px !important;
      }
    }
  }

  .card {
    z-index: 5;
    margin-bottom: 25px;
  }

  .nsearch {
    z-index: 11;
  }

  .butonConfir {
    background-color: #ffffff;
    color: #000000;
    margin-top: 20px;
  }

  .map {
    margin: 20px 0;

    ${({ theme }) => theme.styles.itemWidth}
    height: 500px;
    width: 100vw;
  }
`;
